import React, { useState, useEffect } from 'react';
import Footer from '../../layout/Footer';
import ViewIncomeCategory from './ViewIncomeCategory';
import { Container, Row, Col, Card, Form, Nav } from 'react-bootstrap';
import SimpleBarReact from "simplebar-react";
import { toast } from 'react-toastify'
import IncomeCategoryData from "./income-category-data.json";
import { getFromAPI, postToAPI, putToAPI, formatISODateWithTimezone } from '../../../Utils/utils';
import { IncomeProvider, useIncome } from './getIncome';
import { IncomeContext1 } from './incomeContext';
import  messages from '../../../Utils/lang';

// Icons
import Icon from '@mdi/react';
import { mdiFormatListBulletedSquare, mdiPlus, mdiMagnify } from '@mdi/js';
import FormInputs from '../../../Utils/FormInputs';

function IncomeCategory() {

    const [incomeData, setIncomeData] = useState([]);
    const [incomeCategoryId, setIncomeCategoryId] = useState('');
    const { incomCategoryeData, fetchIncomeData } = useIncome();
    const [searchTerm, setSearchTerm] = useState('');

    const initialInputData = {
        category_name: '',
        description: '',
        isexpense: 0,
        created_branch_id: 0,
        created_user_id: 0,
        last_modfied_user_id: 0,
        created_date_time: formatISODateWithTimezone(new Date()),
        last_modified_date_time: formatISODateWithTimezone(new Date()),
        isdeleted: 0
    }
    const [inputData, setInputData] = useState({ ...initialInputData });

    const handleIncCatCancel = () => {
        setInputData({ ...initialInputData });
        setIncomeCategoryId('');
    };

    useEffect(() => {
        fetchIncomeData(setIncomeData);
    }, [incomeCategoryId]);

    const handleIncCatSubmit = async () => {
        if (!inputData.category_name || !inputData.category_name.trim()) {
            toast.error(messages.incomeCategory.required_category_name);
            return;
        }
        if (!inputData.description || !inputData.description.trim()) {
            toast.error(messages.incomeCategory.required_description);
            return;
        }

        // Check income category exists
        const existingCategory = incomCategoryeData.find(item => item.category_name.toLowerCase() === inputData.category_name.toLowerCase());
        if (existingCategory) {
            toast.error(messages.incomeCategory.already_exist);
            return;
        }

        try {
            const response = await postToAPI('FtsExpenseCategory/', inputData);
            if (response.status) {
                toast.success(messages.incomeCategory.added_successfully);
                setInputData(initialInputData);
                fetchIncomeData();
                // Get the ID of the newly added product
                const newUnitId = response.data.id;

                // Set the newly added product as selected
                setIncomeCategoryId(newUnitId);
                // Switch to view tab
                const viewCategoryTab = document.getElementById("pills-view-income-category-tab");
                if (viewCategoryTab) {
                    viewCategoryTab.click();
                }
                // Set focus and highlight the new unit in sidebar
                setTimeout(() => {
                    const sidebarItem = document.querySelector(`.left-link-item[data-id="${newUnitId}"] a`);
                    if (sidebarItem) {
                        // Remove active class from all items
                        const allLinks = document.querySelectorAll(".left-link-item a");
                        allLinks.forEach(link => link.classList.remove("active"));

                        // Add active class to new item
                        sidebarItem.classList.add("active");
                        sidebarItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                }, 100);
            } 
        } catch (error) {
            toast.error('An unexpected error occurred', 'error');
        }
    };

    const filteredIncomeCategoryData = incomCategoryeData.filter(admin =>
        admin.category_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    useEffect(() => {
        const sidebarItems = document.querySelectorAll(".left-link-item"); // Use querySelectorAll for better targeting

        // Loop over all sidebar items
        sidebarItems.forEach((item) => {
            item.addEventListener('click', function () {
                // Remove active class from all sidebar links
                const activeLink = document.querySelector(".left-link-item a.active");
                if (activeLink) activeLink.classList.remove("active");

                // Add active class to the clicked item
                const link = this.querySelector('a');
                if (link) link.classList.add('active');

                // Update selected vendor ID
                const expenseId = this.getAttribute('data-id');
                setIncomeCategoryId(expenseId);

                // Trigger click on the "View Unit" tab
                const expenseUnitTab = document.getElementById("pills-view-income-category-tab");
                if (expenseUnitTab) {
                    expenseUnitTab.click();  // Ensure the tab is switched programmatically
                }

            });
        });

        // Cleanup listeners on component unmount
        return () => {
            sidebarItems.forEach((item) => {
                item.removeEventListener('click', () => { });
            });
        };
    }, [filteredIncomeCategoryData]);

    // Modified useEffect to handle initial selection and updates
    useEffect(() => {
    if (incomCategoryeData.length > 0) {
        if (!incomeCategoryId || !incomCategoryeData.find(income => income.id === incomeCategoryId)) {
            setIncomeCategoryId(incomCategoryeData[0].id);
            setFocusOnSidebarItem(incomCategoryeData[0].id);
        }
    }
    }, [incomCategoryeData, setIncomeCategoryId]);

    const setFocusOnSidebarItem = (unitId) => {
        // Remove active class from all items
        const allLinks = document.querySelectorAll(".left-link-item a");
        allLinks.forEach(link => link.classList.remove("active"));

        // Add active class to the new item
        const newItem = document.querySelector(`.left-link-item[data-id="${unitId}"] a`);
        if (newItem) {
            newItem.classList.add("active");
            newItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
};

    const handleIncCatInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const incCatRows = [
        {
            columns: [
                { size: { md: 12 }, label: 'Income Category Name', type: 'text', placeholder: 'Enter income category name...', name: 'category_name', id: 'category_name', value: inputData.category_name, errormsg: '', },
                { size: { sm: 12 }, label: 'Income Description', type: 'textarea', placeholder: 'Type expense description...', name: 'description', formrow: '4', id: 'description', value: inputData.description, errormsg: '', },
            ],
        },
    ];
    const incCatButtons = [
        { variant: "primary", text: "Add", onClick: handleIncCatSubmit },
        { variant: "secondary", text: "Cancel", onClick: handleIncCatCancel },
    ];

    return (
        <>
            <IncomeContext1.Provider value={incomeCategoryId}>

                <div className="page-wrapper">
                    <div className='page-content'>
                        <Container>
                            <Row>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <div className='d-md-flex justify-content-between align-items-center'>
                                                <Form className='custom-form-width'>
                                                    <div className='custom-search-bar'>
                                                        <Icon path={mdiMagnify} size={1} className="custom-search-input-icon" />
                                                        <Form.Control className='' type="text" placeholder={`Search income category from ${filteredIncomeCategoryData.length} from income category`} name='unitSearch' id='unitSearch' onChange={handleSearchChange} value={searchTerm} />
                                                    </div>
                                                </Form>
                                                <div className="custom-top-nav-tab mt-3 mt-md-0">
                                                    <ul className="nav nav-pills btn-list" id="pills-tab" role="tablist">
                                                        <li className="nav-item" role="presentation">
                                                            <button className="nav-link active" id="pills-view-income-category-tab" data-bs-toggle="pill" data-bs-target="#pills-view-income-category" type="button" role="tab" aria-controls="pills-view-income-category" aria-selected="true">
                                                                <Icon path={mdiFormatListBulletedSquare} className="btn-icon me-1" />View Income Category
                                                            </button>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <button className="nav-link" id="pills-new-income-category-tab" data-bs-toggle="pill" data-bs-target="#pills-new-income-category" type="button" role="tab" aria-controls="pills-new-income-category" aria-selected="false">
                                                                <Icon path={mdiPlus} className="btn-icon me-1" />New Income Category
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={4} xxl={3}>
                                    <Card className='procust-left-list leftbar-list'>
                                        <SimpleBarReact>
                                            <Card.Body>
                                                <div className='left-list-bar'>
                                                    {filteredIncomeCategoryData.map((data, i) =>
                                                        <Nav.Item className='left-link-item' key={i} data-id={data.id} onClick={() => {
                                                            setIncomeCategoryId(data.id);
                                                            setFocusOnSidebarItem(data.id);
                                                        }}>
                                                    
                                                            <Nav.Link className={data.id === incomeCategoryId ? "active" : ""}>
                                                                <h5 className='product-tab-title'>{data.category_name}</h5>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    )}
                                                </div>
                                            </Card.Body>
                                        </SimpleBarReact>
                                    </Card>
                                </Col>
                                <Col lg={8} xxl={9}>

                                    <div className="tab-content custom-top-nav-tab" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-view-income-category" role="tabpanel" aria-labelledby="pills-view-income-category-tab" tabIndex="0">
                                            <ViewIncomeCategory setIncomeCategoryId={setIncomeCategoryId} />
                                        </div>
                                        <div className="tab-pane fade" id="pills-new-income-category" role="tabpanel" aria-labelledby="pills-new-income-category-tab" tabIndex="0">
                                            <Card className='right-content-details'>
                                                <Card.Body>
                                                    <Card.Title>New Income Category</Card.Title>
                                                    <FormInputs Buttons={incCatButtons} rows={incCatRows} handleInputChange={handleIncCatInputChange} handleSubmit={handleIncCatSubmit} />
                                                
                                                    {/* <Form>
                                                        <div className="mb-3 custom-form-input">
                                                            <Form.Label>Income Category Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder='Enter Expense Category Name...'
                                                                name='category_name'
                                                                id='category_name'
                                                                value={inputData.category_name}
                                                                onChange={e => setInputData({ ...inputData, category_name: e.target.value })}
                                                            />
                                                        </div>
                                                        <div className="mb-3 custom-form-input">
                                                            <Form.Label>Income Description</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                placeholder='Type income description...'
                                                                rows={4} name='description'
                                                                id='description'
                                                                value={inputData.description}
                                                                onChange={e => setInputData({ ...inputData, description: e.target.value })}


                                                            />
                                                        </div>
                                                    </Form> */}
                                                </Card.Body>
                                                {/* <div className='custom-card-footer'>
                                                    <div className='text-end btn-list'>
                                                        <Button variant="primary" onClick={handleAddIncomeCategoryData}>Add</Button>{' '}
                                                        <Button variant="secondary" onClick={handleCancel}>Cancel</Button>{' '}
                                                    </div>
                                                </div> */}
                                            </Card>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Footer />
                </div>
            </IncomeContext1.Provider>
        </>
    )
}

export default function CustomersWithProvider() {
    return (
        <IncomeProvider>
            <IncomeCategory />
        </IncomeProvider>
    );
}